<script lang="ts" setup>
    import MediaTextCard from "@/components/MediaTextCard.vue";
    import { type MediaCard } from "@interfaces/MediaCard";
    import { computed } from "vue";
    import VueHorizontal from "vue-horizontal";

    let props = defineProps({
        mediaCards: {
            type: Array as PropType<MediaCard[]>,
            required: true
        },
        title: {
            type: String,
            required: false
        },
        titleColor: {
            type: String,
            default: ""
        },
        desktopBackgroundImage: {
            type: String,
            default: ""
        },
        mobileBackgroundImage: {
            type: String,
            default: ""
        },
        isSlider: {
            type: Boolean,
            default: false
        },
        hasPadding: {
            type: Boolean,
            default: true
        },
    });

    let cssProps = computed(() => {
        return {
            "--desktop-img-url": `url(${props.desktopBackgroundImage})`,
            "--mobile-img-url": `url(${props.mobileBackgroundImage ? props.mobileBackgroundImage : props.desktopBackgroundImage})`,
            backgroundSize: `100% 100%`,
            backgroundRepeat: `no-repeat`
        };
    });

    let hasTitle = computed(() => {
        return props.title !== "";
    });
</script>
<template>
    <div>
        <div
            v-if="!props.isSlider"
            :class="{
                'featured_content': true,
                'featured_content-noPadding': !props.hasPadding,
                'featured_content_bg_img': true,
            }"
            :style="cssProps"
        >
            <span
                v-if="hasTitle"
                :class="
                    props.titleColor
                        ? `featured_content-title headline-l text-${props.titleColor}`
                        : `featured_content-title headline-l`
                "
                id="media_slider_title"
                role="heading"
                aria-level="2"
                >{{ props.title }}</span
            >
            <div class="featured_content-column">
                <div
                    class="featured_content-container"
                    style="background-color: white; padding: 2rem"
                >
                    <media-text-card
                        v-for="(card, index) in props.mediaCards"
                        :key="index"
                        v-bind="card"
                    />
                </div>
            </div>
        </div>
        <div v-else>
            <div
                :class="props.hasPadding ?
                    `featured_content featured_content_bg_img hide-on-mobile` : 
                    `featured_content-noPadding featured_content_bg_img hide-on-mobile`"
                :style="cssProps"
            >
                <span
                    :class="
                        props.titleColor
                            ? `featured_content-title headline-l text-${props.titleColor}`
                            : `featured_content-title headline-l`
                    "
                    id="media_slider_title"
                    role="heading"
                    aria-level="2"
                    >{{ props.title }}</span
                >
                <div class="featured_content-column">
                    <div
                        class="featured_content-container"
                        style="background-color: white; padding: 2rem"
                    >
                        <media-text-card
                            v-for="(card, index) in props.mediaCards"
                            :key="index"
                            v-bind="card"
                        />
                    </div>
                </div>
            </div>
            <div
                :class="props.hasPadding ? 
                    `featured_content featured_content_bg_img show-on-mobile` : 
                    `featured_content-noPadding featured_content_bg_img show-on-mobile`"
                :style="cssProps"
            >
                <span
                    :class="
                        props.titleColor
                            ? `featured_content-title headline-l text-${props.titleColor}`
                            : `featured_content-title headline-l`
                    "
                    id="media_slider_title"
                    role="heading"
                    aria-level="2"
                    >{{ props.title }}</span
                >
                <vue-horizontal
                    responsive
                    scroll
                    :button="false"
                    class="featured_content-container"
                >
                    <media-text-card
                        v-for="(card, index) in props.mediaCards"
                        :key="index"
                        class="carousel-item"
                        v-bind="card"
                        :isSlider="props.isSlider"
                        :cta="card.cta"
                        :mediaProps="card.mediaProps"
                    />
                </vue-horizontal>
            </div>
        </div>
    </div>
</template>
